import React, { useEffect, useState } from 'react'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import { Container } from 'react-bootstrap'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomForm from '../Components/CustomForm/CustomForm'
import axios from "axios";
import API_URL from '../config/api'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { addSetting, fetchAdminSettings, fetchSetting } from '../hooks/settings'

function Settings() {
  const navigate=useNavigate();
  const dispatch = useDispatch();
  const { userArray } = useSelector((state) => state.auth);
  const { list } = useSelector((state) => state.settings);
  
useEffect(() => {
            dispatch(fetchAdminSettings())

}, [dispatch])
  const infoData = [
    {
      id: 0,
      title: "معلومات أساسية",
      inputs: [
        { id: "next_cycle_start", title: "وقت الغلق", type: "time" },
        { id: "next_cycle_end", title: "وقت التشغيل", type: "time" },
      ],
    },
  ];
  // const infoData = [
  //   {
  //     id: 0,
  //     title: "معلومات أساسية",
  //     inputs: [
  //       { id: "name", title: "الاسم", type: "text" },
  //       { id: "identity_number", title: "الرقم العسكري", type: "text" },
  //       { id: "rank", title: "الرتبة", type: "text" },
  //       { id: "work_place", title: "جهة العمل", type: "text" },
  //       {
  //         id: "restaurant",
  //         title: "اختار المطعم",
  //         type: "select",
  //         options: ["مطعم معهد الشرطه المستجدين", "مطعم معهد الرتب الاخرى"],
  //       },

  //       // 👇 ضيف الحقول المطلوبة من API
  //       { id: "email", title: "البريد الإلكتروني", type: "email" },
  //       { id: "password", title: "كلمة المرور", type: "password" },
  //       { id: "password_confirmation", title: "تأكيد كلمة المرور", type: "password" },
  //       { id: "phone", title: "رقم الهاتف", type: "text" },
  //       { id: "username", title: "اسم المستخدم", type: "text" },
  //       { id: "national_number", title: "الرقم العسكري", type: "text" },
  //     ],
  //   },
  // ];


  const handleSubmit = async (formData) => {
    console.log(formData);
            dispatch(addSetting(formData))
          .unwrap()
          .then(() => {
            dispatch(fetchAdminSettings())
            alert('تم إضافة  بنجاح');
    
          })
          .catch((err) => {
            alert(err);
          });

  };
  return (
    <div>
      <AuthNavbar />
      <Container>
        <CustomHeader
          title={"إضافة الاعدادات"}
          subtitle={""}
          downloadData={false}
        />
        <CustomForm
          formStructure={infoData}
          image={false}
          onSubmit={handleSubmit}
initialData={list}
        />
      </Container>
    </div>
  )
}

export default Settings
